var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button-icon',{class:("v-btn-danger " + _vm.classP),attrs:{"icon":"mdi-trash-can","disabled":_vm.disabled,"loading":_vm.loading}},[(_vm.isSlot)?[_vm._t("default")]:[_vm._v(" Pašalinti ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }